import { Card } from "primereact/card";
import React, { useState } from "react";
import { inject, observer } from "mobx-react";

import CreateNode from "@Common/CreateNode";
import { changeValByPath } from "@utils";

import "./style.scss";
import moment from "moment";
import ButtonUI from "@UI/ButtonUI";

const UnloadLeads = inject("mainStore")(
    observer(({ mainStore }) => {
        const offers = mainStore.getMainStore("suggest.offers_suggest") || [];
        const vendors = mainStore.getMainStore("modified.vendors_suggest") || [];

        const [data, setData] = useState({
            vendorId: null,
            siteId: null,
            offerIds: [],
            dateTimeStart: null,
            dateTimeEnd: null,
        });

        const setStateData = (path, value) => {
            const field = path.join(".");
            setData((prev) => ({ ...prev, [field]: value }));
        };

        const setStateDataMulti = (array) => {
            let currentData = { ...data };
            array.forEach(({ path, value }) => {
                const fullPath = path.join(".");
                currentData = changeValByPath(fullPath, value, currentData);
            });
            setData(currentData);
        };

        const isFormValid = Object.entries(fields)
            .filter(([_, field]) => field.required)
            .every(([key]) => {
                const val = data[key];
                return Array.isArray(val) ? val.length > 0 : !!val;
            });
        const downloadHandler = async (e) => {
            const obj = { ...data };
            if (obj.vendorId) {
                obj.offerIds = obj.offerIds?.length > 0 ? obj.offerIds : offers.filter((f) => f.vendorId == obj.vendorId).map((m) => m._id);
                delete obj.vendorId;
            }

            const startMonth = data.dateTimeStart ? moment(data.dateTimeStart).format("MMMM") : "";
            const endMonth = data.dateTimeEnd ? moment(data.dateTimeEnd).format("MMMM") : "";
            const monthLabel = startMonth && endMonth ? (startMonth === endMonth ? startMonth : `${startMonth}–${endMonth}`) : moment().format("MMMM");

            const resp = await mainStore.downloadFile(
                `/reports/getleads`,
                obj,
                {
                    headers: {
                        "content-type": "application/json",
                    },
                    responseType: "blob",
                },
                `RIS_${vendors[data.vendorId].name}_${monthLabel}_лиды.xlsx`,
            );
        };

        return (
            <div className="unload-leads">
                <Card
                    title={() => (
                        <span className="unload-leads__title">
                            Выгрузка / <span className="unload-leads__title_gray">Лиды</span>
                        </span>
                    )}
                >
                    {Object.keys(fields).map((key) => {
                        const val = data && data[key] ? data[key] : "";
                        return (
                            <CreateNode
                                key={key}
                                fullData={data}
                                keyTo={key}
                                item={fields[key]}
                                value={val}
                                setDataMulti={setStateDataMulti}
                                setStateData={setStateData}
                                isAdd={false}
                                dataId={[key]}
                                disabled={false}
                                siteId={null}
                                multiple={false}
                                changeableData={data}
                            />
                        );
                    })}

                    <ButtonUI severity="success" icon="pi pi-download" label="Выгрузить" disabled={!isFormValid} onClick={downloadHandler} />
                </Card>
            </div>
        );
    }),
);

export default UnloadLeads;

const fields = {
    vendorId: {
        label: "Выберите вендора",
        type: "select",
        dataKey: "suggest.vendors_suggest",
        optionValue: "_id",
        optionLabel: "name",
        selectedItemKey: "_id",
        filterBy: "name,_id",
        showSelectAll: true,
    },
    siteIds: {
        label: "Выберите витрину на котором используются",
        type: "multiSelect",
        dataKey: "suggest.sites_suggest",
        optionValue: "_id",
        optionLabel: "name",
        selectedItemKey: "_id",
        filterBy: "name,_id",
        showSelectAll: true,
    },
    offerIds: {
        label: "Выберите офферы",
        type: "multiSelect",
        dataKey: "suggest.offers_suggest",
        optionValue: "_id",
        optionLabel: "title",
        selectedItemKey: "_id",
        filterBy: "title,_id",
        showSelectAll: true,
        addClass: "full",
        filterFunction: ({ options, currentValue }) => {
            if (currentValue.vendorId && currentValue.vendorId.length && options && options.length > 0) {
                let newOptions = options.filter((it) => {
                    return currentValue.vendorId === it.vendorId;
                });

                return newOptions;
            }
            return [];
        },
    },
    dateTimeStart: { label: "Дата начала периода", type: "dateTime", required: true },
    dateTimeEnd: { label: "Дата окончание периода", type: "dateTime", required: true },
};
